import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened the credit pack downgrade confirmation modal',
  name: 'credit_pack_downgrade_initiated',
  params: [
    {
      description: 'Subscription plan name',
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Credit pack quantity currently on the subscription',
      name: 'existing_pack_quantity',
      required: true,
      type: 'number',
    },
    {
      description: 'Credit pack quantity the user is committing to',
      name: 'pack_quantity',
      required: true,
      type: 'number',
    },
    {
      description: 'Whether a credit pack change is already queued on the subscription',
      name: 'credit_pack_change_pending',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Number of credits remaining in the current cycle',
      name: 'credits_remaining',
      required: true,
      type: 'number',
    },
    {
      description: 'Percentage of credits used',
      name: 'pct_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of credits used in the current cycle',
      name: 'credits_used',
      required: true,
      type: 'number',
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
    {
      description: 'Surface that opened the manage credit packs flow',
      name: 'source',
      required: false,
      type: 'enum',
      values: [
        'settings_manage_plan',
        'settings_current_plan_card',
        'settings_pending_changes_banner',
        'plans_modal',
        'checkout',
        'nudge',
        'hard_block',
        'side_nav',
        'canvas',
      ],
    },
  ],
};

export default META;
